export enum Size {
  LARGE = 'large',
  MEDIUM = 'medium',
  SMALL = 'small',
  XX_LARGE = 'xx-large',
  XX_SMALL = 'xx-small',
  X_LARGE = 'x-large',
  X_SMALL = 'x-small',
}
